import { Input, Table, TableColumnsType } from "antd";
import AddIcon from "components/Icons/AddIcon";
import NextIcon from "components/Icons/NextIcon";
import PreviousIcon from "components/Icons/PreviousIcon";
import { sortIcon } from "components/Table";
import { RouteName } from "constants/route";
import { IReferral } from "models/referral";
import { useState } from "react";
import usePromoCode from "hooks/promoCodes/usePromoCode";
import { Link } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";
import { IPromoCode } from "models/promoCode";
import moment from "moment";

export default function PromoCodes() {
  const [activeTab, setActiveTab] = useState<"promo" | "referral">("promo");
  const {
    referrals,
    promoCodes,
    handleSearch,
    handlePromoCodePageChange,
    handleReferralPageChange,
  } = usePromoCode();

  const handleTabClick = (tab: "promo" | "referral") => {
    setActiveTab(tab);
  };

  return (
    <div className="w-full bg-white p-5 rounded-lg shadow">
      <div className="flex justify-center mb-5">
        <div className="flex">
          <div
            className={`tab-text ${
              activeTab === "promo" ? "font-semibold" : ""
            } mr-4 cursor-pointer`}
            onClick={() => handleTabClick("promo")}
          >
            Promo
          </div>
          <div
            className={`tab-text ${
              activeTab === "referral" ? "font-semibold" : ""
            } cursor-pointer`}
            onClick={() => handleTabClick("referral")}
          >
            Referral
          </div>
        </div>
      </div>
      <div className="tab-content">
        {activeTab === "promo" && (
          <div>
            <div className="w-full px-6 flex flex-wrap-reverse">
              <div className="grow justify-between items-center flex-wrap-reverse gap-5">
                <Link
                  to={RouteName.NEW_PROMO}
                  className="flex items-center p-3 border rounded-lg border-black w-fit gap-x-2"
                >
                  <AddIcon />
                  <span className="text-black text-sm font-medium">
                    Add New
                  </span>
                </Link>
              </div>
              <Input
                className="max-w-72 w-full h-auto px-4 py-2 text-base border border-[rgb(0,0,0,0.1)] rounded-3xl"
                prefix={<SearchOutlined className="mr-2" />}
                placeholder="Search..."
                onChange={handleSearch}
                // value={search}
              />
            </div>
            <div className="w-full mt-8 px-4">
              <Table
                loading={promoCodes.loading}
                columns={promoColumns}
                dataSource={promoCodes.data}
                onChange={handlePromoCodePageChange}
                pagination={{
                  total: promoCodes.total,
                  pageSize: promoCodes.per_page,
                  current: promoCodes.page,
                  nextIcon: (
                    <span className="flex items-center justify-center w-8 h-8 text-2xl">
                      <NextIcon />
                    </span>
                  ),
                  prevIcon: (
                    <span className="flex items-center justify-center w-8 h-8 text-2xl">
                      <PreviousIcon />
                    </span>
                  ),
                }}
              />
            </div>
          </div>
        )}
        {activeTab === "referral" && (
          <div>
            <div className="w-full  px-6 flex flex-wrap-reverse">
              <Input
                className="max-w-72 w-full h-auto px-4 py-2 text-base border border-[rgb(0,0,0,0.1)] rounded-3xl"
                prefix={<SearchOutlined className="mr-2" />}
                placeholder="Search..."
                onChange={handleSearch}
                // value={search}
              />
            </div>
            <div className="w-full mt-8 px-4">
              <Table
                loading={referrals.loading}
                columns={referralColumns}
                dataSource={referrals.data}
                onChange={handleReferralPageChange}
                pagination={{
                  total: referrals.total,
                  pageSize: referrals.per_page,
                  current: referrals.page,
                  nextIcon: (
                    <span className="flex items-center justify-center w-8 h-8 text-2xl">
                      <NextIcon />
                    </span>
                  ),
                  prevIcon: (
                    <span className="flex items-center justify-center w-8 h-8 text-2xl">
                      <PreviousIcon />
                    </span>
                  ),
                }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const referralColumns: TableColumnsType<IReferral> = [
  {
    title: "Referrer Name",
    dataIndex: ["referrer", "first_name"],
    render: (_, record) =>
      `${record.referrer.first_name} ${record.referrer.last_name}`,
    sortIcon,
  },
  {
    title: "Referred Name",
    dataIndex: ["referred", "first_name"],
    render: (_, record) =>
      `${record.referred.first_name} ${record.referred.last_name}`,
    sortIcon,
  },
  {
    title: "Mile",
    dataIndex: "mile",
    sortIcon,
    sorter: (a, b) => a.mile.localeCompare(b.mile),
  },
  {
    title: "Type",
    dataIndex: "type",
    sortIcon,
    sorter: (a, b) => a.type.localeCompare(b.type),
  },
];

const promoColumns: TableColumnsType<IPromoCode> = [
  {
    title: "Name",
    dataIndex: "name",
    sortIcon,
  },
  {
    title: "Quantity",
    dataIndex: "quantity",
    sortIcon,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    sortIcon,
    sorter: (a, b) => a.amount - b.amount,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    render: (createdAt) => moment(createdAt).format("ll"),
    sortIcon,
    sorter: (a, b) =>
      new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
  },
];
